export default "__VITE_ASSET__DMOKRpej__"